import React, { useEffect, useState } from "react";
import Navbar from "./Navbar/Navbar";
import LandingPage from "./Landing/LandingPage";
import Header from "./Header/Header";
import BottomNavbar from "./BottomNavbar/BottomNavbar";
import AllCategory from "./Category/AllCategory";
import Experience from "./Experience/Experience";
import Calculate from "./calculate/Calculate";
import Franchise from "./Franchise/Franchise";
import Feedback from "./FeedBack/Feedback";
import Question from "./Question/Question";
import Footer from "./Footer/Footer";
import Offer from "./Offer/Offer";
import Certificate from "./CertificatePage/Certificate";
import CardDemo from "./CardDemo";
import { Button } from "react-bootstrap";
import Lottie from "lottie-react";
import { FaThumbsUp, FaThumbsDown } from "react-icons/fa";
import supportAnimation from "./assets/Anim/Anim.json";
import FloatingSupportMenu from "./FloatingSupportMenu/FloatingSupportMenu";

export default function Home() {
  const [isMobile, setIsMobile] = useState(false);
  const [feedback, setFeedback] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const handleFeedback = (type) => {
    setFeedback(type);
    setSubmitted(true);
    // TODO: send to backend API if needed
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize(); // initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Header />
      <AllCategory />
      <BottomNavbar />
      <Experience />
      <Offer />
      <Calculate />
      <Franchise />
      <br></br>
      <br></br>
      <Feedback />
      <br></br>
      <Question />
      <br></br>
      <Certificate />
      <br></br>
      <div className="mt-4 p-3 border-top">
        {!submitted ? (
          <>
            <p className="mb-2 fw-bold" style={{ textAlign: "center" }}>
              Was this information helpful?
            </p>
            <div className="d-flex gap-3 flex-wrap justify-content-center">
              <Button
                variant="outline-success"
                className="d-flex align-items-center gap-2"
                onClick={() => handleFeedback("like")}
              >
                <FaThumbsUp /> Yes
              </Button>
              <Button
                variant="outline-danger"
                className="d-flex align-items-center gap-2"
                onClick={() => handleFeedback("dislike")}
              >
                <FaThumbsDown /> No
              </Button>
            </div>
          </>
        ) : (
          <p className="text-success mt-2" style={{ textAlign: "center" }}>
            Thank you for your feedback! 🙏
          </p>
        )}
      </div>
      <br></br>
      <Footer />

      <div className="fixed bottom-4 right-4 z-50 block md:block">
        <FloatingSupportMenu />
      </div>
    </>
  );
}
